export default "__VITE_ASSET__DvnrmR9B__"